export enum RoleEnum {
	engineer = 23, //Инженер СЦ
	partnerServiceCenterEngineer = 9, //Инженер СЦ партнера
	storekeeper = 10, // Сотрудник склада
	selfEmployedEngineer = 13, //Самозанятый инженер,
	master = 3,
	specialist = 22,
}